import { RateSelectionReason } from './RateSelectionReason';

export class AcceptRateQuoteRequest {
  rateQuoteId?: number;
  rateSelectionReason?: RateSelectionReason;

  constructor(opts?: Partial<AcceptRateQuoteRequest>) {
    if (opts?.rateQuoteId != null) {
      this.rateQuoteId = opts.rateQuoteId;
    }
    if (opts?.rateSelectionReason != null) {
      this.rateSelectionReason = new RateSelectionReason(
        opts.rateSelectionReason,
      );
    }
  }
}
